<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    :current-page="page"
    :page-sizes="[10, 20, 30, 40]"
    :page-size="page_size"
    layout="total, sizes, prev, pager, next, jumper"
    :total="total"
    style="margin-top: 20px;"></el-pagination>
</template>

<script>
export default {
  props: {
    total: Number,
  },
  data() {
    return {
      page: 1,
      page_size: 10,
      
    }
  },
  methods: {
    handleSizeChange(val) {
      this.page = 1
      this.page_size = val
      this.$emit('size-change', val)
    },
    handleCurrentChange(val) {
      this.page = val
      this.$emit('current-change', val)
    },
  },
}
</script>

<style>

</style>
